import React, { useContext, useEffect, useState } from 'react';
import { Context as Auth } from '../../../services/auth/AuthContext';
import {
  Table
} from 'antd';
import Spinner from '../../../components/navigation/Spinner';
import '../../../components/layout/layout.css';
import { getVideosubByQuery } from '../../../services/videosub.service';
import { useTranslation } from 'react-i18next';
import { capitalize } from '../../../utils/utils';
import UserVideoModal from '../../../components/modals/UserVideoModal';
import moment from 'moment';
import ReactPlayer from 'react-player';
moment.locale('es');

const UserVideosub = (props) => {
  const { user } = useContext(Auth);
  const [loading, setLoading] = useState(true);
  const [videosub, setVideosub] = useState(null);
  const [videos, setVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [videoModalVisible, setVideoModalVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (user.account) {
      loadVideoSubs(user.account._id);
    }
  }, [user.account]);

  const loadVideoSubs = async (userId) => {
    const { status, data } = await getVideosubByQuery({ account: userId, isActive: true }, user.token);
    if (status === 200) {
      setVideosub(data.data[0] || null);
      const videosArr = data.data[0]?.videos.map((video) => {
        if (video.isVisible) {
          return video;
        }
        return null;
      }) || [];
      setVideos(videosArr.filter(video => video !== null));
      setLoading(false);
    }
  };

  const columns = [
    {
      title: capitalize(t('videos')),
      key: 'all',
      width: 360,
      // eslint-disable-next-line react/display-name
      render: (record) => (
        <React.Fragment>
          {record.name || '-'}
          <br />
          {record.description || '-'}
          <br />
        </React.Fragment>
      ),
      sorter: {
        compare: (a, b) => a.name.localeCompare(b.name),
        multiple: 5
      },
      responsive: ['xs']
    },
    {
      title: capitalize(t('name')),
      key: 'name',
      width: '30%',
      ellipsis: true,
      // eslint-disable-next-line react/display-name
      render: (record) => record.name || '-',
      responsive: ['sm']
    },
    {
      title: capitalize(t('description')),
      key: 'description',
      width: '70%',
      ellipsis: true,
      // eslint-disable-next-line react/display-name
      render: (record) => record.description || '-',
      responsive: ['md']
    }
  ];

  function onChange (pagination, filters, sorter, extra) {

  }

  if (loading) {
    return (
      <Spinner/>
    );
  }

  if (!videosub || videosub.isActiveSub === false) {
    return (
      <>
        <h2>{capitalize(t('videos'))}</h2>
        <div style={{
          backgroundColor: '#fff',
          padding: 18,
          border: '1px solid #f0f0f0',
          borderRadius: 8,
          marginBottom: 18,
          display: 'flex',
          flexDirection: 'column',
          gap: 8
        }}>
          <div style={{
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: 14,
            display: 'flex',
            flexDirection: 'column'
          }}>
            {capitalize(t('noVideosubFoundUser'))}
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div>
        <h2>{capitalize(t('videos'))}</h2>
        <div style={{
          backgroundColor: '#fff',
          padding: 18,
          border: '1px solid #f0f0f0',
          borderRadius: 8,
          marginBottom: 18,
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          position: 'relative'
        }}>

          <div style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: 14
          }}>
            <div style={{
              fontWeight: 500
            }}>{capitalize(t('name'))}:</div> {videosub?.name || '-'}
          </div>

          <div style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: 14
          }}>
            <div style={{
              fontWeight: 500
            }}>{capitalize(t('description'))}:</div> {videosub?.description || '-'}
          </div>
        </div>
      </div>
      <Table
        columns={columns}
        dataSource={videos}
        rowKey={(record) => record._id || record.id || record.key || record.url || `${record.name || 'row'}-${record.created || ''}`}
        tableLayout="fixed"
        scroll={{ x: 'max-content' }}
        onChange={onChange}
        onRow={(record, rowIndex) => {
          return {
            onClick: event => {
              setSelectedVideo(record);
              setVideoModalVisible(true);
            },
            onDoubleClick: event => {}, // double click row
            onContextMenu: event => {}, // right button click row
            onMouseEnter: event => {}, // mouse enter row
            onMouseLeave: event => {} // mouse leave row
          };
        }}
        rowClassName={'row-pointer'}
      />
      <br />
      {videoModalVisible && (
        <UserVideoModal
          videoModalVisible={videoModalVisible}
          setVideoModalVisible={setVideoModalVisible}
          video={selectedVideo?.url ? selectedVideo.url : null}
          height={'80%'}
        />
      )}
    </>
  );
};

export default UserVideosub;
